export const TOP_LEVEL_ROUTES = {
	recruitment: 'recruitment',
	pageNotFound: 'pagenotfound',
	resources: 'resources',
	joinOurNetwork: 'joinournetwork',
	error: 'error',
	features: 'features',
	termsAndConditions: 'termsconditions',
	privacy: 'privacy',
};

export const AREA_ROUTES = {
	providers: 'providers',
	fitnessCenters: 'fitness',
	faq: 'faq',
	members: 'members',
};
